import fetch from 'utils/fetch';
import { Labeled, Originator, Params, Result } from 'types';
import { useCachedFetch } from 'utils/use-cached-fetch';
import { useQuery } from 'react-query';

export function useEndMethods() {
  return useCachedFetch<Labeled[]>('/api/originator/ending-methods');
}

export function useEndTypes() {
  return useCachedFetch<Labeled[]>('/api/originator/ending-types');
}

export function useGeoObjectTypes() {
  return useCachedFetch<Labeled[]>('/api/originator/geo-object-types');
}

export function useOriginMethods() {
  return useCachedFetch<Labeled[]>('/api/originator/origin-methods');
}

export function useOriginTypes() {
  return useCachedFetch<Labeled[]>('/api/originator/origin-types');
}

export function useOriginatorClasses() {
  const classes =
    useCachedFetch<Labeled[]>('/api/originator/originator-classes') || [];
  return [{ id: 'ALL', label: 'Vše' }, ...classes];
}

export function useOriginatorNameTypes() {
  return useCachedFetch<Labeled[]>('/api/originator/origin-name-types');
}

export function useSubClasses() {
  return useCachedFetch<Labeled[]>('/api/originator/sub-classes');
}

export async function postOriginators(
  params: Params
): Promise<Result<Originator>> {
  const response = await fetch('/api/originator/list', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params),
  });
  const json = await response.json();

  return json;
}

export async function getOriginatorDetail(id?: string): Promise<Originator> {
  const response = await fetch(`/api/originator/${id}`);

  const json: Originator = await response.json();
  return json;
}
export const useOriginatorDetail = (id?: string) =>
  useQuery(['originator', id], () => getOriginatorDetail(id), {
    enabled: !!id,
  });
